import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {FormWrapper} from "../items/form.wrapper";
import {KeyValuePipe} from "@angular/common";
import {TranslateDirective, TranslatePipe} from "@ngx-translate/core";
import {AbstractFormFieldComponent} from "../abstract-form-field.component";
import {ValidationErrors} from "@angular/forms";
import {isDefined} from "../../utils/epic.utils";

@Component({
  selector: 'acc-form-field-error',
  imports: [
    TranslatePipe,
    TranslateDirective,
    KeyValuePipe
  ],
  templateUrl: './form-field-error.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './form-field-error.component.css'
})
export class FormFieldErrorComponent extends AbstractFormFieldComponent {

  private static readonly ERRORS_IGNORE: string[] = [
    'email',
    'number',
    'numeric',
    'integer',
    'min',
    'max',
    'constructionDate',
    'ngbDate',
    'hyperlink'
  ];

  @Input({required: true})
  public name!: string;

  @Input({required: true})
  public wrapper!: FormWrapper;

  protected getErrors(): string[] {
    if (this._isInvalid(this.name, this.wrapper)) {
      const errors: ValidationErrors | null = this.wrapper.form.controls[this.name].errors;
      return isDefined(errors)
        ? Object.keys(errors).filter((k) => !FormFieldErrorComponent.ERRORS_IGNORE.includes(k))
        : [];
    }
    return [];
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  protected getTranslation(key: any, params?: object): string {
    if (typeof key === 'string') {
      return this.i18n.translate(key, params);
    }
    return '';
  }

  protected hasError(errorCode: string): boolean {
    if (this._isInvalid(this.name, this.wrapper)) {
      return this.wrapper.form.controls[this.name].hasError(errorCode);
    }
    return false;
  }
}
